import qrImg from '../../assets/qr.png'

const address = 'Tan Hung Ward, District 7, HCM'
const email = 'qnpdev@gmail.com'
const phone = '08.2222.6618'
const phone2 = '0333.61.66.64'
const facebook = {
    link: '100029121395944',
    show: 'fb.com/NPQuii'
}
const github = {
    link: 'https://github.com/qnpDev',
    show: 'github.com/qnpDev'
}
const qr = {
    show: qrImg,
    link: 'https://drive.google.com/file/d/14sl3pdu9FosheQoWeFRtCAtlq4_g3I15/view?usp=sharing',
}
export { address, email, phone, phone2, facebook, github, qr }